import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { bulkSparesTableColumnsConfig } from "./bulkSparesTableColumnDef";

import { Table } from "../../../../component/table/Table";
import { CategoryPageSkeleton } from "../../../../component/skeleton/CategoryPageSkeleton";
import { selectBulkSparesFilterState } from "../../../../store/bulk/bulkSparesFilterSlice";
import {
  selectBulkSpares,
  useGetBulkSpareListQuery,
} from "../../../../services/bulk/spares/bulkSparesApiSlice";
import { toast } from "react-toastify";
import { bulkDealDownloadRequest } from "../../../../http-request/bulk_deals/bulkDealsDownloadFie";

export const BulkSparesTablePage = () => {
  const navigate = useNavigate();

  /* ✅ Get filters from redux */
  const { seller_id, status } = useSelector(selectBulkSparesFilterState);

  /* ✅ Call RTK Query with filters */
  const { isLoading, isError, isSuccess } = useGetBulkSpareListQuery({
    seller_id,
    status,
  });

  /* ✅ Get normalized data from entity adapter */
  const bulkSpareList = useSelector(selectBulkSpares);

  const handleNavigate = useCallback(
    (request_id) => {
      navigate(`/bulk_deals/spares/${request_id}`);
    },
    [navigate],
  );

  const handleDownload = useCallback(async (requestId) => {
    try {
      toast.success("downloading...");
      const fileData = await bulkDealDownloadRequest({
        category: "spares",
        requestId: requestId,
      });

      const contentType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const blob = new Blob([fileData], { type: contentType });

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `mobiGarage_${requestId}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Error occurred during download:", err);
      toast.success("error while downloading");
    }
  }, []);

  const columnDefs = useMemo(
    () => bulkSparesTableColumnsConfig(handleDownload, handleNavigate),
    [handleDownload, handleNavigate],
  );

  if (isError) return <div>Something went wrong</div>;

  return isSuccess ? (
    <Table data={bulkSpareList} columns={columnDefs} loading={isLoading} />
  ) : (
    <CategoryPageSkeleton />
  );
};
